"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.divisionsLoaded = exports.divisions = void 0;
const divisions = (state) => state.divisions.divisions;
exports.divisions = divisions;
const divisionsLoaded = (state) => state.divisions.divisionsLoaded;
exports.divisionsLoaded = divisionsLoaded;
